 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import ReactGA from 'react-ga4'
import {LocalStorageKey} from '~/types/constEnums'

import safeIdentify from './safeIdentify'

import graphql from 'babel-plugin-relay/macro'
import {commitLocalUpdate} from 'relay-runtime'


graphql`
  fragment handleSuccessfulLogin_UserLogInPayload on UserLogInPayload {
    userId
    authToken
    isNewUser
    user {
      id
      tms
      isPatient0
      ...UserAnalyticsFrag @relay(mask: false)
    }
  }
`








export const emitGA4SignUpEvent = (args) => {
  const {isNewUser, userId, isPatient0} = args
  if (isNewUser) {
    ReactGA.event('sign_up', {
      userId,
      user_properties: {
        is_patient_0: isPatient0
      },
      is_patient_0: isPatient0
    })
  }
}

export const handleSuccessfulLogin = (atmosphere, payload) => {
  const email = _optionalChain([payload, 'optionalAccess', _ => _.user, 'optionalAccess', _2 => _2.email])
  const userId = _optionalChain([payload, 'optionalAccess', _3 => _3.user, 'optionalAccess', _4 => _4.id])
  if (!email || !userId) return
  window.localStorage.setItem(LocalStorageKey.EMAIL, email)
  safeIdentify(userId, email)
  const isNewUser = _nullishCoalesce(_optionalChain([payload, 'optionalAccess', _5 => _5.isNewUser]), () => ( false))
  commitLocalUpdate(atmosphere, (store) => {
    const root = store.getRoot()
    root.setValue(isNewUser, 'isNewUser')
  })
  emitGA4SignUpEvent({isNewUser, userId, isPatient0: payload.user.isPatient0})
}
